export enum AchievementTypeEnum {
  TROPHY = 'trophy',
  ACHIEVEMENT = 'achievement'
}